module.exports = __webpack_public_path__ + "img/btn.6f56861f.png";